import { render, staticRenderFns } from "./ScreenBlocksSettings.vue?vue&type=template&id=5d1e26d0&scoped=true"
import script from "./ScreenBlocksSettings.vue?vue&type=script&lang=js"
export * from "./ScreenBlocksSettings.vue?vue&type=script&lang=js"
import style0 from "./ScreenBlocksSettings.vue?vue&type=style&index=0&id=5d1e26d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e26d0",
  null
  
)

export default component.exports